module.exports = __webpack_public_path__ + "static/media/bg-survey-complete.bca5f4b3.png";